@if (routerLink(); as routerLink) {
  <a
    class="navigation-link__item"
    routerLinkActive="navigation-link__item--active"
    ariaCurrentWhenActive="page"
    tooltipPosition="right-center"
    showTooltipOnlyOnDesktop
    kdsPrefetch
    [routerLink]="routerLink"
    [kdsTooltip]="linkName()"
    [disableTooltip]="!isTooltipEnabled()"
    (isActiveChange)="setNavigationItemIfActive($event)"
    (click)="setNavigationItemIfActive(true)"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </a>
} @else {
  <span
    class="navigation-link__item"
    tooltipPosition="right-center"
    showTooltipOnlyOnDesktop
    [kdsTooltip]="linkName()"
    [disableTooltip]="!isTooltipEnabled()"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </span>
}

<ng-template #linkContent>
  @if (iconClass(); as iconClass) {
    <div aria-hidden="true" class="navigation-link__item-icon">
      <i class="navigation-link__item-icon-image {{ iconClass }}"></i>
    </div>
  }
  <span class="navigation-link__item-text">{{ linkName() }}</span>
  <ng-content />
</ng-template>
